import { useContext, useState } from 'react';
import EditAccomplishment from './EditAccomplishment/EditAccomplishment';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { AuthContext } from '../../../../../../lib/context/AuthContext';
import AddAccomplishment from './AddAccomplishment/AddAccomplishment';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from '@mui/material';
import {
  MainWrapper,
  TitleWrapper,
  InfosWrapper,
  WrapperInfoIcon,
  Type,
  Date,
  InfoWrapper,
  IconButtonWrapper,
  Desc,
  Title,
} from '../styles';
import { useTranslation } from 'react-i18next';
import { formatDateWithNumbers } from '../../../../../../utils/formaters/formatDate';

export default function Accomplishments() {
  const { user } = useContext(AuthContext);
  const [openAddModal, setOpenAddModal] = useState<boolean>(false);
  const [openEditModal, setOpenEditdModal] = useState<boolean>(false);

  const [item, setItem] = useState<any>();

  const { t } = useTranslation();
  return (
    <MainWrapper>
      <TitleWrapper>
        <Title>{t('more_info.accomplishments')}</Title>
        <IconButton>
          <AddCircleIcon onClick={() => setOpenAddModal(true)} />
        </IconButton>
      </TitleWrapper>
      {user && user.accomplishments && user.accomplishments.length > 0 ? (
        user?.accomplishments?.map((field, index) => {
          return (
            <InfosWrapper>
              <WrapperInfoIcon>
                <InfoWrapper>
                  <Type>{field.accomplishmentName}</Type>
                  <Date>
                    {formatDateWithNumbers(
                      field.startMonth,
                      field.startYear,
                      field.endMonth,
                      field.endYear
                    )}
                  </Date>
                </InfoWrapper>
                <InfoWrapper>
                  <Desc>{field.description}</Desc>
                </InfoWrapper>
              </WrapperInfoIcon>
              <IconButtonWrapper size="small">
                <EditIcon
                  onClick={() => {
                    setOpenEditdModal(true);
                    setItem(field);
                  }}
                />
              </IconButtonWrapper>
            </InfosWrapper>
          );
        })
      ) : (
        <Type>
          {t(
            'editProfile.edit_candidate_profile.accomplishment.no_accomplishments'
          )}
        </Type>
      )}
      <EditAccomplishment
        field={item}
        open={openEditModal}
        setOpen={setOpenEditdModal}
      />
      <AddAccomplishment
        setItem={setItem}
        open={openAddModal}
        setOpen={setOpenAddModal}
      />
    </MainWrapper>
  );
}
